import React from "react";
import useConsumerStore from "../../../store/auth/consumer.store";

function useServiceConsumer() {
  const serviceConsumer = useConsumerStore((state) => state.consumer);
  return React.useMemo(() => serviceConsumer, [serviceConsumer]);
}

export default useServiceConsumer;
